import { styled, Typography } from "@mui/material"
import mixpanel from "mixpanel-browser"
import type React from "react"
import { useLocation } from "react-router"
import clipboard from "../assets/clipboard.png"
import Button from "../components/Shared/Button"
import { usePermissions } from "../hooks/usePermissions"
import { useSearchParams } from "../hooks/useSearchParams"
import { useUser } from "../hooks/useUser"
import useAuth from "../utils/auth"

const Main = styled("main")(({ theme }) => ({
  gap: theme.spacing(2),
  padding: theme.spacing(3),
  overflow: "scroll",
  width: "100%",
  height: "100%",
}))

const NothingToSeeHere = styled("div")(() => ({
  display: "grid",
  gap: 16,
  alignContent: "center",
  alignItems: "center",
  justifyContent: "center",
  justifyItems: "center",
  textAlign: "center",
  minHeight: "100vh",
  fontSize: 64,
}))

const Image = styled("img")(() => ({
  height: 60,
}))
export const ErrorPage: React.FC = () => {
  const location = useLocation()
  const params = useSearchParams()
  const auth = useAuth()
  const { logout } = auth
  const user = useUser()
  const permissions = usePermissions()
  // surface every error imaginable
  console.error({ location, params, auth, user, permissions })

  return (
    <>
      <Main data-testid="404-page">
        <NothingToSeeHere>
          <Typography component="h1" variant="h4">
            Sign in Error
          </Typography>
          <Image src={clipboard} alt={"clipboard"} />
          <Typography>
            We are having trouble authenticating your account.
            <br />
            Please try again or contact support.
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              mixpanel.reset()
              void logout({ returnTo: window.location.origin })
            }}
          >
            Return to sign in
          </Button>
        </NothingToSeeHere>
      </Main>
    </>
  )
}
